import { CreateTableInput } from 'aws-sdk/clients/dynamodb';

export const { MONITORING_TABLE_NAME = 'monitoring' } = process.env;
export const MONITORING_TABLE_SCHEDULER_GSI = 'schedulerGSI';

export const MONITORING_TABLE_SCHEMA: CreateTableInput = {
  TableName: MONITORING_TABLE_NAME,
  KeySchema: [
    { AttributeName: 'hashKey', KeyType: 'HASH' },
    { AttributeName: 'sortKey', KeyType: 'RANGE' },
  ],
  AttributeDefinitions: [
    { AttributeName: 'hashKey', AttributeType: 'S' },
    { AttributeName: 'sortKey', AttributeType: 'S' },
    { AttributeName: 'scheduler', AttributeType: 'S' },
  ],
  ProvisionedThroughput: {
    ReadCapacityUnits: 1,
    WriteCapacityUnits: 1,
  },

  GlobalSecondaryIndexes: [
    {
      IndexName: MONITORING_TABLE_SCHEDULER_GSI,
      KeySchema: [
        { AttributeName: 'scheduler', KeyType: 'HASH' },
        { AttributeName: 'sortKey', KeyType: 'RANGE' },
      ],
      Projection: {
        ProjectionType: 'ALL',
      },
      ProvisionedThroughput: {
        ReadCapacityUnits: 1,
        WriteCapacityUnits: 1,
      },
    },
  ],
};
